query GetCampaigns($search: String, $ids: [ID!], $limit: Int) {
  campaigns(search: $search, ids: $ids, limit: $limit) {
    id
    name
    salesforceId
    recordTypeName
    status
    active
    startDate
    linkedEventId
    linkedEventTitle
  }
}
